import { React, Divider, Text } from 'mondrian-react';
import CardTabelas from './components/CardTabelas';
import CardApis from './components/CardApis';
import logo from '../../../../assets/images/logo-catalogo.svg';
import InputSearch from '../../../../components/InputSearch';
import RadiosSearch from '../../../../components/RadiosSearch';
import { useResults } from '../../../../hooks/results';
import { useResult } from '../../../../hooks/result';
import styles from './styles.module.css';
const { useEffect, useState, useLayoutEffect } = React;

function Results({
  term,
  handleKeyPress,
  handleButtonPress,
  onChange,
  index,
  selectIndex,
}) {
  const [scrollPosition, setPosition] = useState(0);
  const { setText, info, setInfo } = useResults();
  const { setResult } = useResult();

  useLayoutEffect(() => {
    function updatePosition() {
      setPosition(window.pageYOffset);
    }
    window.addEventListener('scroll', updatePosition);
    updatePosition();

    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  useEffect(() => {
    return () => {
      setText('');
      setInfo('');
    };
  }, [term, setText, setInfo]);

  return (
    <div className={`mdn-Container ${styles.ContainerResults}`}>
      <div
        className={
          scrollPosition > 300
            ? styles.ContainerResultsHeaderSticky
            : styles.ContainerResultsHeader
        }
        id="ContainerResultsHeader"
      >
        <a href="/">
          <img
            className={styles.LogoResults}
            src={logo}
            alt="Logo - Claro Catálogo"
          />
        </a>

        <div className={styles.InputAndRadios}>
          <div className={styles.InputSearchResults}>
            <InputSearch
              term={term}
              handleKeyPress={handleKeyPress}
              handleButtonPress={handleButtonPress}
              onChange={(e) => onChange(e.target.value)}
            />
          </div>
          <RadiosSearch
            index={index}
            selectIndex={selectIndex}
            className={styles.RadioIndex}
          />
        </div>
      </div>

      <Divider />

      {term && info && (
        <Text body className={styles.ResultsCaption}>
          Sua busca por “{term}” retornou {info?.data?.hits?.hits?.length}{' '}
          {info?.data?.hits?.hits?.length < 2 ? 'resultado' : 'resultados'}.
        </Text>
      )}

      {info?.data?.hits?.hits[0]?._index === 'tabelas' && (
        <CardTabelas dataSet={info?.data?.hits?.hits} onClick={setResult} />
      )}

      {info?.data?.hits?.hits[0]?._index === 'apis' && (
        <CardApis dataSet={info?.data?.hits?.hits} onClick={setResult} />
      )}
    </div>
  );
}

export default Results;
